import angular from "angular";

angular
    .module('app')
    .component('commentForm', {
        template: require('./comment-form.html'),
        controller: ['$http', 'Notifier', 'trans', 'moment', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller($http, Notifier, trans, moment) {

    let $ctrl = this;

    $ctrl.$onInit = function () {
        $ctrl.comment = $ctrl.resolve.comment;
        $ctrl.text = $ctrl.comment.text;
        $ctrl.courseId = $ctrl.resolve.course.id;
        $ctrl.lessonId = $ctrl.resolve.lesson.id;
    };

    $ctrl.submit = function () {
        $ctrl.loading = true;
        $http
            .post(`/cabinet/courses/${$ctrl.courseId}/lessons/${$ctrl.lessonId}/comments/${$ctrl.comment.id}/update-comment`, {
                _method: 'PUT',
                text: $ctrl.text
            })
            .then(
                function () {
                    $ctrl.comment.text = $ctrl.text;
                    $ctrl.comment.is_updated = true;
                    $ctrl.comment.updated_at = moment();
                    Notifier.success(trans('Changes saved'), 3);
                    $ctrl.loading = false;
                    $ctrl.close();
                },
                function (error) {
                    Notifier.error(error.data.message, 3);
                    $ctrl.loading = false;
                }
            );
    };

}
